import * as type from './PatientType';
export const initialState = {
    patients: [],
    patient: {
        profile: null
    },
    allPatients: {
        list: null,
        loadMore: false,
        total: null
    },
    listOfPatients: []
};

export const patientReducer = (state = initialState, action) => {
    switch (action.type) {
        case type.SET_SELECTED_PATIENT:
            return { ...state, patient: { ...state.patient, profile: action.payload } };
        case type.GET_PATIENT.SUCCESS:
            return { ...state, patient: { ...state.patient, profile: action.payload } };
        case type.GET_PATIENTS.SUCCESS:
            return { ...state, patients: action.payload };
        case type.PENDING_LOAD_MORE_PATIENTS:
            return {
                ...state,
                allPatients: { ...state.allPatients, loadMore: action.payload }
            };
        case type.DELETE_PATIENT:
            return {
                ...state,
                allPatients: {
                    loadMore: false,
                    list: state.allPatients.list?.filter((item) => item.id !== action.payload)
                }
            };
        case type.LOAD_PATIENTS.SUCCESS: {
            const { offset, limit } = action.params;
            if (offset === 0) {
                return {
                    ...state,
                    allPatients: {
                        list: action.payload,
                        loadMore: action.payload && action.payload.length === 0 ? 'ALL' : false,
                        total: action.total
                    }
                };
            } else if (state.allPatients && state.allPatients.list) {
                return {
                    ...state,
                    allPatients: {
                        list: [...state.allPatients.list, ...action.payload],
                        loadMore:
                            action.payload &&
                            (action.payload.length === 0 || action.payload.length < limit)
                                ? 'ALL'
                                : false,
                        total: state.allPatients.total
                    }
                };
            } else {
                return {
                    ...state,
                    allPatients: {
                        list: action.payload,
                        loadMore:
                            action.payload &&
                            (action.payload.length === 0 || action.payload.length < limit)
                                ? 'ALL'
                                : false,
                        total: state.allPatients.total
                    }
                };
            }
        }

        // case 'GET_PATIENT_REPORT':
        //     return { ...state, allPatientsReport: action.payload };
        case type.LIST_OF_SELECT_PATIENTS:
            return { ...state, listOfPatients: action.payload };
        // }
        case type.ADD_PATIENT_TO_LIST:
            return { ...state, listOfPatients: [...state?.listOfPatients, action.payload] };
        case type.DELETE_SELECTED_PATIENT:
            return {
                ...state,
                listOfPatients: state.listOfPatients.filter((item) => item.id !== action.payload)
            };
        case type.DEL_ALL_SELECTED_PATIENT:
            return {
                ...state,
                listOfPatients: []
            };
        case type.SUMMON_PATIENT: {
            const updatedPatient = state.patients.map((item) =>
                item.id === action.payload.id ? action.payload : item
            );
            return {
                ...state,
                patients: updatedPatient
                // allPatients: {
                //     list: [...state.allPatients.list, action.payload],
                //     loadMore: false
                // }
            };
        }
        default:
            return state;
    }
};
